import ApiBase from '../../../api-base'
import { ACTIVE_BASE_REST } from '../../../constants'
export default class RecordFurnitureItem extends ApiBase {
  constructor(store) {
    const path = ACTIVE_BASE_REST + '/record/tariff/furniture/item'
    super(store, path)
  }
}
